import { NgModule } from "@angular/core";
import { AbsolutePipe } from "./absolute.pipe";

@NgModule({
    declarations: [AbsolutePipe],
    imports: [],
    exports: [AbsolutePipe],
})
export class PipesModule {}
